// Verdrahtung des gemeinsamen Aktualisieren-Hinweises (F7) mit App-State,
// Ebenen und Fußzeile. Weitere Beiträge (z. B. Assets) registrieren sich direkt
// über registerOrderUpdateProvider aus order_update_service.mjs.
import { S } from '../app/app_state.js?v=20260817c';
import { colorCatalogState } from '../../../colors/color_catalog_registry.js?v=20260720a';
import { colorRevisionChangeVersion } from '../../../colors/color_revision_state.js';
import { getProjectModelRevision } from './project_revision_service.js';
import { drawingSheetProjects } from './drawing_sheet_service.js?v=20260904c';
import { colorOrderUpdateProvider } from './color_order_updates.js';
import {
  configureOrderUpdateHost,
  onOrderUpdateCount,
  registerOrderUpdateProvider,
  scheduleOrderUpdateCheck
} from './order_update_service.mjs';

const identities = new WeakMap();
let nextIdentity = 1;
function identity(value) {
  if (!value || typeof value !== 'object') return 0;
  if (!identities.has(value)) identities.set(value, nextIdentity++);
  return identities.get(value);
}

export function orderUpdateContext() {
  return { project: S.project, sheets: drawingSheetProjects() };
}

function orderUpdateSignature() {
  return [identity(S.project), identity(S.drawingSheets), S.drawingSheets?.activeSheetId || '',
    getProjectModelRevision(), colorRevisionChangeVersion(), colorCatalogState()].join('|');
}

function renderBadge(count) {
  if (typeof document === 'undefined') return;
  const badge = document.getElementById('orderUpdateBadge');
  if (!badge) return;
  badge.hidden = !(count > 0);
  badge.textContent = count === 1 ? '1 neuerer Katalogstand' : `${count} neuere Katalogstände`;
  badge.title = 'Der Auftrag verwendet ältere Katalogstände. Klicken zum Prüfen und Aktualisieren.';
}

let installed = false;
export function installOrderUpdates() {
  if (installed) return;
  installed = true;
  configureOrderUpdateHost({ signature: orderUpdateSignature, context: orderUpdateContext });
  registerOrderUpdateProvider(colorOrderUpdateProvider);
  onOrderUpdateCount(renderBadge);
  if (typeof document === 'undefined') return;
  document.addEventListener('ks-color-catalogs-changed', () => scheduleOrderUpdateCheck({ force: true }));
  document.addEventListener('click', event => {
    if (!event.target?.closest?.('#orderUpdateBadge')) return;
    import('../app/lazy_dialog_runtime.js?v=20260904f')
      .then(runtime => runtime.openOrderUpdateModal())
      .catch(error => console.error('Dialog „Auftrag aktualisieren“ konnte nicht geöffnet werden.', error));
  });
}

export { scheduleOrderUpdateCheck };
